import React, { useContext } from 'react';

import { AnalyticsApi } from '../apis';
import { api } from '../api';

const AnalyticsApiContext = React.createContext(new AnalyticsApi(api));

export const AnalyticsApiProvider = AnalyticsApiContext.Provider;
export const useAnalyticsApi = (): AnalyticsApi => useContext(AnalyticsApiContext);
